import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  close: {
    id: 'linkCreate.createForm.button.close',
    defaultMessage: 'Close',
    description: 'Button to close and dismiss link create'
  },
  create: {
    id: 'linkCreate.createForm.button.create',
    defaultMessage: 'Create',
    description: 'Button to submit the form and Create object'
  }
});